<template>
    <div class="cards-banner">
        <CCol class="card-col">
            <div class="card-box list-item">
                <div class="noselect container">
                    <h1>
                        <b>{{ item.title }}</b>
                    </h1>
                    <p>Expire : {{ item.expire }}</p>
                </div>
                <img :src="item.img" class="img-cover" width="100%" />
            </div>
        </CCol>
    </div>
</template>

<script>
    import { ElementMixin } from "vue-slicksort";
    export default {
        name: "sortableItem",
        mixins: [ElementMixin],
        props: ["item"]
    };
</script>

<style scoped>
    .img-cover {
        object-fit: cover;
        width: 100%;
        height: fit-content;
    }
    h1 {
        text-align: right;
        font-size: 45px;
        margin-right: 20px;
        margin-top: 10px;
    }
    p {
        text-align: center;
        margin-bottom: 20px;
        font-size: 15px;
    }
    .banner-topic {
        font-size: 23px;
        padding-bottom: 20px;
    }
    .underline {
        display: inline-block;
        font-size: 22px;
        text-decoration: none;
    }
    .underline::after {
        content: "";
        display: block;
        width: 50%;
        border-bottom: 3px solid orangered;
    }
    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
    }
    @media only screen and (min-device-width: 600px) and (max-device-width: 800px) {
        .cards-banner {
            margin-right: -4rem;
        }
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        .cards-banner {
            margin-right: -5rem;
        }
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {
        .cards-banner {
            margin-right: -5rem;
        }
    }
    @media only screen and (min-device-width: 900px) and (max-device-width: 1600px) {
        .cards-banner {
            margin-right: -3rem;
        }
    }
    @media only screen and (min-device-width: 1080px) and (max-device-width: 1366px) {
        .cards-banner {
            margin-right: -7rem;
        }
    }
    @media only screen and (device-width: 1080px) and (device-width: 1920px) {
        .cards-banner {
            margin-right: -7rem;
        }
    }
    .card-col {
        margin: 0 auto;
        display: flex;
        height: 100%;
        max-width: 100%;
        max-height: 283px;
        border-bottom-left-radius: 10%;
        border-bottom-right-radius: 10%;
    }
    .card-body {
        padding: 0;
    }
    .card-box {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        min-width: 0;
        margin-bottom: 1.5rem;
        word-wrap: break-word;
        background-clip: border-box;
        background-color: #fff;
        padding: 0;
        cursor: grab;
    }
    .list-item {
        width: 220px;
        border-radius: 10%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    }
    .list-item:hover {
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    }
    .cols {
        float: right;
    }

    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        border: 0;
        color: orange;
        background-image: none;
        border-bottom: 1px solid rgb(209, 207, 207);
    }
    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 4em;
        height: 2em;
        line-height: 1;
        overflow: hidden;
        border-radius: 0.25em;
    }
    select {
        flex: 1;
        color: orange;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
    }
    /* Arrow */
    .select::after {
        content: "\25BC";
        position: absolute;
        top: 8px;
        right: 0;
        padding: 0 0.5em;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: 0.25s all ease;
        -o-transition: 0.25s all ease;
        transition: 0.25s all ease;
        color: rgb(209, 207, 207);
    }
    select option {
        color: orange;
        font-weight: bold;
    }
    .btn-banner {
        float: right;
        padding: 10px;
    }
    .btn-up {
        width: 100px;
        font-size: 16px;
        font-weight: bold;
        margin-right: 10px;
    }
</style>
